module.exports = __webpack_public_path__ + "static/media/JS_Icon.3cacc98a.jpeg";